import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { CheckCircle2, Star } from "lucide-react";

const PAYMENT_LABEL = { cash: "Cash", card: "Card", account: "Account" };

const Row = ({ label, value, testid }) => (
  <div className="flex justify-between gap-4 py-2 border-b border-border text-sm">
    <span className="text-muted-foreground">{label}</span>
    <span className="font-semibold text-right" data-testid={testid}>{value || "—"}</span>
  </div>
);

export const CompletionSummaryDialog = ({ ride, onRate, onDone }) => {
  if (!ride) return null;
  const fare = typeof ride.fare === "number" ? `£${ride.fare.toFixed(2)}` : "—";
  const driver = ride.driver;
  const vehicle = [driver?.vehicle_make, driver?.vehicle_plate].filter(Boolean).join(" · ");
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onDone(); }}>
      <DialogContent className="max-w-md" data-testid="trip-completed-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-black tracking-tight flex items-center gap-2">
            <CheckCircle2 className="w-6 h-6 text-[#10B981]" /> Trip completed
          </DialogTitle>
          <DialogDescription>Thanks for riding with us.</DialogDescription>
        </DialogHeader>
        <div className="text-center py-3">
          <div className="label-mini text-muted-foreground">FINAL FARE</div>
          <div className="font-heading text-4xl font-black" data-testid="trip-completed-fare">{fare}</div>
        </div>
        <div>
          <Row label="Payment" value={PAYMENT_LABEL[ride.payment_method] || ride.payment_method} testid="trip-completed-payment" />
          <Row label="From" value={ride.pickup_address} testid="trip-completed-pickup" />
          <Row label="To" value={ride.dropoff_address} testid="trip-completed-dropoff" />
          {ride.distance_km != null && <Row label="Distance" value={`${ride.distance_km} km`} testid="trip-completed-distance" />}
          <Row label="Driver" value={[driver?.name, vehicle].filter(Boolean).join(" — ")} testid="trip-completed-driver" />
        </div>
        <div className="flex gap-2 pt-2">
          {driver && ride.passenger_rating == null && (
            <Button variant="outline" className="flex-1" onClick={onRate} data-testid="trip-completed-rate-btn">
              <Star className="w-4 h-4 mr-1" /> Rate driver
            </Button>
          )}
          <Button className="flex-1 bg-[#0A0A0A] text-white" onClick={onDone} data-testid="trip-completed-done-btn">
            Done
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
